import { render, staticRenderFns } from "./MailHistory.vue?vue&type=template&id=1394a0b4&scoped=true&"
import script from "./MailHistory.vue?vue&type=script&lang=js&"
export * from "./MailHistory.vue?vue&type=script&lang=js&"
import style0 from "./MailHistory.vue?vue&type=style&index=0&id=1394a0b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394a0b4",
  null
  
)

export default component.exports